<div class="modal metatrader-pswd">
  <button class="close-round" [mat-dialog-close]="false">
    <span class="close-round__btn"></span>
  </button>

  <h1 class="h1 metatrader-pswd__title" translate="metatrader-pswd-popup.title"></h1>
  <p class="metatrader-pswd__text" translate="metatrader-pswd-popup.text"></p>
  <div class="actions-wrapper actions-wrapper--popup">
    <button type="button" class="button" [mat-dialog-close]="true" translate="metatrader-pswd-popup.button.confirm"></button>
  </div>
</div>

